// extracted by mini-css-extract-plugin
module.exports = {"root":"collections_root__z9dcj","outerGrid":"collections_outerGrid__81VIV","title":"collections_title__4xOp2","product":"collections_product__dvN_B"};